export function toTitleCase(str: string): string {
    if (typeof str !== "string") return "";

    return str
        .toLowerCase()
        .replace(/(?:^|\s)\w/g, (match) => match.toUpperCase());
}
